import React from 'react';
import {Routes, Route} from "react-router-dom";
import style from "./root.module.scss"
import Main from "./main/Main";
import {LoginPage} from './loginPage/LoginPage';
import { AuthRoute } from '../util/route';
import { DefaultLayout } from '../layouts/default/default';

function ScreensRoot() {

    return (
        <div className={style.app}>
            {/* sadda */}
            <Routes>
                <Route path="/" element={<AuthRoute component={LoginPage} layout={DefaultLayout}/>}/>
                {/* <Route path="/" element={<Main/>}/> */}
                {/* <Route path="/" element={<LoginPage/>}/> */}
                <Route path="/maps" element={<AuthRoute component={Main} layout={DefaultLayout}/>}/>
                {/*<Route exact path="/" component={EpidInc}/>*/}
                {/*<AuthRoute path="/some-page" component={SomePage}/>*/}
                {/*<AuthRoute path="/tables-user" component={TableUsers} layout={Default}/>*/}
                {/*<AuthRoute path="/search-contact" component={EpidInc} layout={Default}/>*/}
            </Routes>
        </div>
    );
}

// const mapStateToProps = state => ({
//     csvList: state.csvList
// });

// export default connect(
//     mapStateToProps,
//     {}
// )(ScreensRoot);

export default ScreensRoot;